import messages from '../containers/QuestionnairePage/messages';

export const QUESTION_SINGLE = 0;
export const QUESTION_MULTIPLE = 1;
export const QUESTION_DESCRIPTION = 3;
export const QUESTION_RATING = 8;
export const QUESTION_SLIDER = 9;
export const QUESTION_OPEN_ENDED = 10;
export const QUESTION_NUMERIC_OPEN_ENDED = 11;
export const QUESTION_RANKING = 12;
export const QUESTION_MATRIX_SINGLE = 13;
export const QUESTION_MATRIX_MULTIPLE = 14;
export const QUESTION_NPS = 15;
export const QUESTION_VAN_WESTENDORP = 16;
export const QUESTION_MAXDIFF = 17;
export const QUESTION_MATRIX_BIPOLAR = 18;
export const QUESTION_DRILLDOWN = 19;
export const QUESTION_MATRIX_OPEN_ENDED = 20;
export const QUESTION_MATRIX_NUMERIC_OPEN_ENDED = 21;
export const QUESTION_MATRIX_CONSTANT_SUM = 22;
export const QUESTION_CONVERSATIONAL = 23;

export const GROUP_BASIC = 'BASIC';
export const GROUP_AB_TEST = 'AB';
export const GROUP_CONJOINT = 'CONJOINT';
export const GROUP_VAN_WESTENDORP = 'VAN_WESTENDORP';
export const GROUP_MAXDIFF = 'MAXDIFF';
export const GROUP_LOOP_MERGE = 'LOOP_AND_MERGE';

export const MATRIX_OE_MEDIA_SUPPORT = [
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
  QUESTION_MATRIX_CONSTANT_SUM,
];

export const QUESTION_TYPE_NODES = [
  QUESTION_CONVERSATIONAL,
  QUESTION_SINGLE,
  QUESTION_MULTIPLE,
  QUESTION_DESCRIPTION,
  QUESTION_RATING,
  QUESTION_SLIDER,
  QUESTION_OPEN_ENDED,
  QUESTION_NUMERIC_OPEN_ENDED,
  QUESTION_RANKING,
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_BIPOLAR,
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
  QUESTION_MATRIX_CONSTANT_SUM,
  QUESTION_DRILLDOWN,
  QUESTION_NPS,
  QUESTION_VAN_WESTENDORP,
];

export const QUESTION_MATRIX_TYPE_LIKERT = [
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
];

export const QUESTION_MATRIX_OPEN_ENDED_TYPES = [
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
  QUESTION_MATRIX_CONSTANT_SUM,
];

export const QUESTION_NEW_MATRIX_TYPE_NODES = [
  ...QUESTION_MATRIX_OPEN_ENDED_TYPES,
  QUESTION_MATRIX_BIPOLAR,
];

export const QUESTION_MATRIX_TYPES = [
  ...QUESTION_MATRIX_TYPE_LIKERT,
  ...QUESTION_NEW_MATRIX_TYPE_NODES,
];

export const QUESTION_MATRIX_TYPE_NODES = [
  ...QUESTION_MATRIX_TYPES,
  QUESTION_CONVERSATIONAL,
  QUESTION_VAN_WESTENDORP,
];

export const NODE_TYPES_NOT_ALLOWED_LOGIC = [
  QUESTION_DESCRIPTION,
  GROUP_BASIC,
  GROUP_LOOP_MERGE,
  GROUP_AB_TEST,
  GROUP_CONJOINT,
  GROUP_VAN_WESTENDORP,
  GROUP_MAXDIFF,
  QUESTION_CONVERSATIONAL,
];

export const NODE_TYPES_SUPPORT_SIMPLE_QUOTAS = [
  QUESTION_SINGLE,
  QUESTION_MULTIPLE,
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_BIPOLAR,
];

export const GROUP_TYPES = [
  GROUP_BASIC,
  GROUP_LOOP_MERGE,
  GROUP_AB_TEST,
  GROUP_CONJOINT,
  GROUP_MAXDIFF,
  GROUP_VAN_WESTENDORP,
];

export const GROUP_TYPES_ALLOW_SIMPLE_QUOTAS = [GROUP_BASIC];
export const GROUP_TYPES_ALLOW_ADVANCED_QUOTAS = [GROUP_BASIC];

export const NODE_ICONS = {
  [QUESTION_SINGLE]: 'single',
  [QUESTION_MULTIPLE]: 'double-tick',
  [QUESTION_OPEN_ENDED]: 'open-ended-new',
  [QUESTION_NUMERIC_OPEN_ENDED]: 'open-ended-numeric-new',
  [QUESTION_DESCRIPTION]: 'description-horizontal',
  [QUESTION_RATING]: 'star_negative',
  [QUESTION_SLIDER]: 'slider',
  [QUESTION_RANKING]: 'ranking',
  [QUESTION_MATRIX_SINGLE]: 'matrix-multiple',
  [QUESTION_MATRIX_MULTIPLE]: 'matrix-multiple',
  [QUESTION_MATRIX_BIPOLAR]: 'bipolar-matrix',
  [QUESTION_DRILLDOWN]: 'drilldown',
  [QUESTION_MATRIX_OPEN_ENDED]: 'matrix-oe',
  [QUESTION_MATRIX_NUMERIC_OPEN_ENDED]: 'matrix-noe-new',
  [QUESTION_MATRIX_CONSTANT_SUM]: 'matrix-cs',
  [QUESTION_NPS]: 'nps',
  [QUESTION_VAN_WESTENDORP]: 'van-westendorp-question',
  [QUESTION_CONVERSATIONAL]: 'star-four-rays',
  [GROUP_BASIC]: 'question-group',
  [GROUP_AB_TEST]: 'ab-group',
  [GROUP_CONJOINT]: 'conjoint',
  [GROUP_VAN_WESTENDORP]: 'van-westendorp-group',
  [GROUP_MAXDIFF]: 'maxdiff-group',
  [GROUP_LOOP_MERGE]: 'loop-merge-boxed',
};

export const QUESTION_TYPE_SINGLE = {
  value: QUESTION_SINGLE,
  label: messages.singleSelection,
  icon: NODE_ICONS[QUESTION_SINGLE],
};

export const QUESTION_TYPE_MULTIPLE = {
  value: QUESTION_MULTIPLE,
  label: messages.multipleSelection,
  icon: NODE_ICONS[QUESTION_MULTIPLE],
};

export const QUESTION_TYPE_OPEN_ENDED = {
  value: QUESTION_OPEN_ENDED,
  label: messages.openEnded,
  icon: NODE_ICONS[QUESTION_OPEN_ENDED],
};

export const QUESTION_TYPE_NUMERIC_OPEN_ENDED = {
  value: QUESTION_NUMERIC_OPEN_ENDED,
  label: messages.openEndedNumeric,
  icon: NODE_ICONS[QUESTION_NUMERIC_OPEN_ENDED],
};

export const QUESTION_TYPE_MATRIX_OPEN_ENDED = {
  value: QUESTION_MATRIX_OPEN_ENDED,
  label: messages.openEndedMatrix,
  icon: NODE_ICONS[QUESTION_MATRIX_OPEN_ENDED],
  isNew: true,
};

export const QUESTION_TYPE_DESCRIPTION = {
  value: QUESTION_DESCRIPTION,
  label: messages.descriptionQuestion,
  icon: NODE_ICONS[QUESTION_DESCRIPTION],
};

export const QUESTION_TYPE_SLIDER = {
  value: QUESTION_SLIDER,
  label: messages.sliderQuestion,
  icon: NODE_ICONS[QUESTION_SLIDER],
};

export const QUESTION_TYPE_RATING = {
  value: QUESTION_RATING,
  label: messages.ratingQuestion,
  icon: NODE_ICONS[QUESTION_RATING],
};

export const QUESTION_TYPE_RANKING = {
  value: QUESTION_RANKING,
  label: messages.rankingQuestion,
  icon: NODE_ICONS[QUESTION_RANKING],
};

export const QUESTION_TYPE_MATRIX = {
  value: QUESTION_MATRIX_SINGLE,
  label: messages.matrixQuestion,
  icon: NODE_ICONS[QUESTION_MATRIX_SINGLE],
};

export const QUESTION_TYPE_CONSTANT_SUM = {
  value: QUESTION_MATRIX_CONSTANT_SUM,
  label: messages.constantSum,
  icon: NODE_ICONS[QUESTION_MATRIX_CONSTANT_SUM],
  // isNew: true,
};

export const QUESTION_TYPE_NPS = {
  value: QUESTION_NPS,
  label: messages.npsLabel,
  icon: NODE_ICONS[QUESTION_NPS],
};

export const QUESTION_TYPE_VAN_WESTENDORP = {
  value: QUESTION_VAN_WESTENDORP,
  label: messages.vanWestendorpLabel,
  icon: NODE_ICONS[QUESTION_VAN_WESTENDORP],
};

export const QUESTION_TYPE_DRILLDOWN = {
  value: QUESTION_DRILLDOWN,
  label: messages.drilldownLabel,
  icon: NODE_ICONS[QUESTION_DRILLDOWN],
};

export const GROUP_TYPE_BASIC = {
  value: GROUP_BASIC,
  label: messages.groupLabel,
  icon: NODE_ICONS[GROUP_BASIC],
};

export const GROUP_TYPE_LOOP_AND_MERGE = {
  value: GROUP_LOOP_MERGE,
  label: messages.groupLoopAddMergeLabel,
  icon: NODE_ICONS[GROUP_LOOP_MERGE],
  isNew: true,
};

export const GROUP_TYPE_AB = {
  value: GROUP_AB_TEST,
  label: messages.abLabel,
  icon: NODE_ICONS[GROUP_AB_TEST],
};

export const GROUP_TYPE_CONJOINT = {
  value: GROUP_CONJOINT,
  label: messages.conjointLabel,
  icon: NODE_ICONS[GROUP_CONJOINT],
};

export const GROUP_TYPE_VAN_WESTENDORP = {
  value: GROUP_VAN_WESTENDORP,
  label: messages.vanWestendorpLabel,
  labelDisabled: messages.vanWestendorpLabelShort,
  icon: NODE_ICONS[GROUP_VAN_WESTENDORP],
};

export const GROUP_TYPE_MAXDIFF = {
  value: GROUP_MAXDIFF,
  label: messages.maxDiffLabel,
  icon: NODE_ICONS[GROUP_MAXDIFF],
};

export const QUESTION_TYPE_CONVERSATIONAL = {
  value: QUESTION_CONVERSATIONAL,
  label: messages.conversationalQuestion,
  icon: 'star-four-rays',
  wrapperClass: 'conversational-icon-wrapper',
};

export const SCREENING_ICON = 'screening';

export const SCREENING_QUESTION_TYPE_SINGLE = {
  value: QUESTION_SINGLE,
  label: messages.singleSelection,
  icon: SCREENING_ICON,
};

export const SCREENING_QUESTION_TYPE_MULTIPLE = {
  value: QUESTION_MULTIPLE,
  label: messages.multipleSelection,
  icon: SCREENING_ICON,
};

export const NODE_TYPES = [
  QUESTION_TYPE_CONVERSATIONAL,
  QUESTION_TYPE_SINGLE,
  QUESTION_TYPE_MULTIPLE,
  QUESTION_TYPE_OPEN_ENDED,
  QUESTION_TYPE_MATRIX_OPEN_ENDED,
  QUESTION_TYPE_NUMERIC_OPEN_ENDED,
  QUESTION_TYPE_DESCRIPTION,
  QUESTION_TYPE_SLIDER,
  QUESTION_TYPE_RATING,
  QUESTION_TYPE_RANKING,
  QUESTION_TYPE_MATRIX,
  QUESTION_TYPE_CONSTANT_SUM,
  QUESTION_TYPE_DRILLDOWN,
  QUESTION_TYPE_NPS,
  GROUP_TYPE_BASIC,
  GROUP_TYPE_AB,
  GROUP_TYPE_CONJOINT,
  GROUP_TYPE_MAXDIFF,
  GROUP_TYPE_LOOP_AND_MERGE,
];

export const CHOICE_OPEN_ENDED_QUESTIONS = [
  QUESTION_TYPE_CONVERSATIONAL.value,
  QUESTION_TYPE_SINGLE.value,
  QUESTION_TYPE_MULTIPLE.value,
  QUESTION_TYPE_OPEN_ENDED.value,
  QUESTION_TYPE_NUMERIC_OPEN_ENDED.value,
  QUESTION_TYPE_DESCRIPTION.value,
];

export const SCALE_COMPARATIVE_QUESTIONS = [
  QUESTION_TYPE_MATRIX_OPEN_ENDED.value,
  QUESTION_TYPE_SLIDER.value,
  QUESTION_TYPE_RATING.value,
  QUESTION_TYPE_RANKING.value,
  QUESTION_TYPE_MATRIX.value,
  QUESTION_TYPE_CONSTANT_SUM.value,
  QUESTION_TYPE_DRILLDOWN.value,
  QUESTION_TYPE_NPS.value,
];

export const GROUP_QUESTIONS = [GROUP_TYPE_BASIC, GROUP_TYPE_LOOP_AND_MERGE];

export const SCREENING_NODE_TYPES = [
  SCREENING_QUESTION_TYPE_SINGLE,
  SCREENING_QUESTION_TYPE_MULTIPLE,
];

export const NODE_LABEL_BY_TYPE = {
  [QUESTION_SINGLE]: messages.singleSelection,
  [QUESTION_MULTIPLE]: messages.multipleSelection,
  [QUESTION_OPEN_ENDED]: messages.openEnded,
  [QUESTION_NUMERIC_OPEN_ENDED]: messages.openEndedNumeric,
  [QUESTION_DESCRIPTION]: messages.descriptionQuestion,
  [QUESTION_RATING]: messages.ratingQuestion,
  [QUESTION_SLIDER]: messages.sliderQuestion,
  [QUESTION_RANKING]: messages.rankingQuestion,
  [QUESTION_MATRIX_SINGLE]: messages.matrixQuestion,
  [QUESTION_MATRIX_MULTIPLE]: messages.matrixQuestion,
  [QUESTION_MATRIX_BIPOLAR]: messages.matrixQuestion,
  [QUESTION_DRILLDOWN]: messages.drilldownLabel,
  [QUESTION_MATRIX_OPEN_ENDED]: messages.matrixQuestion,
  [QUESTION_MATRIX_NUMERIC_OPEN_ENDED]: messages.matrixQuestion,
  [QUESTION_MATRIX_CONSTANT_SUM]: messages.matrixQuestion,
  [QUESTION_NPS]: messages.npsLabel,
  [QUESTION_VAN_WESTENDORP]: messages.vanWestendorpLabel,
  [GROUP_BASIC]: messages.groupLabel,
  [GROUP_AB_TEST]: messages.abLabel,
  [GROUP_CONJOINT]: messages.conjointLabel,
  [GROUP_VAN_WESTENDORP]: messages.vanWestendorpLabel,
};

export const CARRIED_VALUE_PLACEHOLDERS = {
  [QUESTION_OPEN_ENDED]: 'Open-ended answer',
  [QUESTION_NUMERIC_OPEN_ENDED]: 'Numeric open-ended answer',
  [QUESTION_SLIDER]: 'Slider answer',
};

export const RESEARCH_METHOD_TYPES = [
  GROUP_AB_TEST,
  GROUP_CONJOINT,
  GROUP_MAXDIFF,
  GROUP_VAN_WESTENDORP,
];

export const RESEARCH_TYPE_METHODS = [
  GROUP_TYPE_AB,
  GROUP_TYPE_CONJOINT,
  GROUP_TYPE_MAXDIFF,
  GROUP_TYPE_VAN_WESTENDORP,
];

export const QUESTION_SINGLE_PEEQ = 'Single-Select';
export const QUESTION_MULTIPLE_PEEQ = 'Multi-Select';
export const QUESTION_OPEN_ENDED_PEEQ = 'Text';
export const QUESTION_NUMERIC_OPEN_ENDED_PEEQ = 'Numeric';
export const QUESTION_NEST_PEEQ = 'Nest';

export const NODE_ICONS_PEEQ = {
  [QUESTION_SINGLE_PEEQ]: 'single',
  [QUESTION_MULTIPLE_PEEQ]: 'double-tick',
  [QUESTION_OPEN_ENDED_PEEQ]: 'open-ended',
  [QUESTION_NUMERIC_OPEN_ENDED_PEEQ]: 'open-ended-numeric',
};

export const NODE_TYPES_SUPPORT_COLUMNS = [
  QUESTION_RANKING,
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
  QUESTION_MATRIX_CONSTANT_SUM,
  QUESTION_MATRIX_BIPOLAR,
];

export const NODE_TYPES_SUPPORT_TRANSLATE_OPEN_ENDED = [
  QUESTION_OPEN_ENDED,
  QUESTION_CONVERSATIONAL,
  QUESTION_MATRIX_OPEN_ENDED,
];

export const ALLOWED_UNCONDITIONAL_HIDE_ANSWER_NODE_TYPES = [
  QUESTION_SINGLE,
  QUESTION_MULTIPLE,
  QUESTION_RANKING,
];

export const ALLOWED_UNCONDITIONAL_HIDE_ROW_NODE_TYPES = [
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_BIPOLAR,
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_CONSTANT_SUM,
  QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
];

export const ALLOWED_UNCONDITIONAL_HIDE_COLUMN_NODE_TYPES = [
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
];

export const NODE_TYPES_SUPPORT_QUOTA_ASSIGNMENT = [
  QUESTION_MULTIPLE,
  QUESTION_MATRIX_MULTIPLE,
];
